import appReducers from '../reducer/app';
import salesReducers from "../reducer/sales";
import iamReducers from "../reducer/iam";
import contentReducers from "../reducer/content";
import qnrReducers from "../reducer/qnr";

const rootReducer = {
    ...appReducers,
    ...iamReducers,
    ...salesReducers,
    ...contentReducers,
    ...qnrReducers
};

export default rootReducer;
